/* Fortune Food: CNY prices + festive look.
   - Each product can have a hidden "CNY price twin" (product metafield custom.cny_twin): same sizes, CNY-period prices.
   - When the order planner's date is in the CNY period (cart attribute Period = CNY), items are added to the cart
     as their twin, and items already in the cart are swapped to their twin (and back when the date leaves the period).
     The planner asks the customer to confirm before switching an existing cart to CNY prices.
   - Festive look: <html> gets ff-fest ff-fest--cny (CNY period) or ff-fest--xmas (24 / 25 Dec), with a slim ribbon
     under the header. Christmas changes the look only, not prices.
   - Map of regular -> twin variant ids: section ff-cny-map (cached for the visit). */
(function () {
  if (window.__ffCny) return; window.__ffCny = true;
  function FT(k, en, v) { var d = window.FF_I18N, s = d && typeof d[k] === 'string' && d[k] !== '' ? d[k] : en; return v ? s.replace(/\{(\w+)\}/g, function (m, n) { return v[n] != null ? String(v[n]) : m; }) : s; }
  var CFG = window.FF_CNY || {};
  var state = { cny: CFG.period === 'CNY', busy: false };
  var MAP = null, REV = null, mapP = null;
  var SM = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  var SD = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  var of = window.fetch ? window.fetch.bind(window) : null;

  function loadMap() {
    if (MAP) return Promise.resolve(MAP);
    if (mapP) return mapP;
    var key = 'ffCnyMap:' + (CFG.v || '1');
    try { var c = sessionStorage.getItem(key); if (c) { setMap(JSON.parse(c)); return Promise.resolve(MAP); } } catch (e) {}
    mapP = of('/?section_id=ff-cny-map', { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (html) {
      var d = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-ff-cny-map]');
      var m = d ? JSON.parse(d.textContent).r2c : {};
      try { sessionStorage.setItem(key, JSON.stringify(m)); } catch (e) {}
      setMap(m); return MAP;
    }).catch(function () { mapP = null; setMap({}); return MAP; });
    return mapP;
  }
  function setMap(m) { MAP = {}; REV = {}; Object.keys(m || {}).forEach(function (k) { MAP[k] = String(m[k]); REV[String(m[k])] = k; }); }
  /* Variant id to use for the current period (or null if no change is needed) */
  function swapId(id) {
    id = String(id).split(':')[0];
    if (!MAP) return null;
    if (state.cny && MAP[id]) return MAP[id];
    if (!state.cny && REV[id]) return REV[id];
    return null;
  }
  window.ffCnyActive = function () { return state.cny; };

  /* ---------- adding to cart: add the twin during the CNY period ---------- */
  if (of) {
    window.fetch = function (u, opt) {
      var url = typeof u === 'string' ? u : (u && u.url) || '';
      if (!/\/cart\/add(\.js)?(\?|$)/.test(url) || !opt || !opt.body) return window.__ffCnyFetchNext(u, opt);
      var self = this;
      return loadMap().then(function () {
        try {
          var b = opt.body;
          if (typeof b === 'string' && /^\s*\{/.test(b)) {
            var j = JSON.parse(b), items = j.items || (j.id ? [j] : []), ch = false;
            items.forEach(function (it) { var s = swapId(it.id); if (s) { it.id = +s; ch = true; } });
            if (ch) opt.body = JSON.stringify(j);
          } else if (typeof FormData !== 'undefined' && b instanceof FormData) {
            var s1 = swapId(b.get('id')); if (s1) b.set('id', s1);
          } else if (typeof b === 'string' || (typeof URLSearchParams !== 'undefined' && b instanceof URLSearchParams)) {
            var p = new URLSearchParams(String(b)), s2 = swapId(p.get('id'));
            if (s2) { p.set('id', s2); opt.body = b instanceof URLSearchParams ? p : p.toString(); }
          }
        } catch (e) {}
        return window.__ffCnyFetchNext.call(self, u, opt);
      });
    };
    /* Pass through to whatever fetch was there before (other cart guards wrap fetch too) */
    window.__ffCnyFetchNext = of;
  }
  /* Plain (non-AJAX) form posts are not rewritten: the cart is swapped to match the period on the next page (see start) */

  /* ---------- swap cart lines to match the period ---------- */
  function getCart() { return of('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  function reconcile() {
    if (state.busy) return Promise.resolve(false);
    state.busy = true;
    return loadMap().then(getCart).then(function (c) {
      var ops = [];
      (c.items || []).forEach(function (i) { var s = swapId(i.variant_id); if (s) ops.push({ i: i, to: s }); });
      if (!ops.length) return false;
      var add = ops.map(function (o) { var it = { id: +o.to, quantity: o.i.quantity }; if (o.i.properties && Object.keys(o.i.properties).length) it.properties = o.i.properties; return it; });
      var up = {}; ops.forEach(function (o) { up[o.i.key] = 0; });
      return of('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: add }) })
        .then(function (r) { if (!r.ok) throw new Error('add'); return of('/cart/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ updates: up }) }); })
        .then(function (r) { return r.json(); })
        .then(function (c2) {
          try { document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: c2 } })); document.dispatchEvent(new CustomEvent('ff:cart-changed')); document.dispatchEvent(new CustomEvent('cart:build')); } catch (e) {}
          return true;
        });
    }).catch(function () { return false; }).then(function (ch) { state.busy = false; return ch; });
  }
  window.ffCnyReconcile = reconcile;

  /* ---------- festive look ---------- */
  /* New Year dates come from the planner data on the page (Delivery settings > New Year dates) */
  var NY = (function () { try { var n = document.querySelector('script.ffd-data'); return n ? (JSON.parse(n.textContent).nyDates || []) : []; } catch (e) { return []; } })();
  function festOf(iso, cny) { if (cny) return 'cny'; if (iso && /-12-2[45]$/.test(iso)) return 'xmas'; if (iso && NY.indexOf(iso) > -1) return 'ny'; return ''; }
  function niceDate(k) { var a = k.split('-'), d = new Date(Date.UTC(+a[0], +a[1] - 1, +a[2])); return FT('fmt_chip', '{wd} {d} {mon}', { wd: FT('sd', SD.join('|')).split('|')[d.getUTCDay()], d: d.getUTCDate(), mon: FT('sm', SM.join('|')).split('|')[d.getUTCMonth()], m: d.getUTCMonth() + 1, y: d.getUTCFullYear() }); }
  function ribbonText(f, iso) {
    if (f === 'cny') return '<b>' + FT('rib_cny', 'Chinese New Year order') + '</b>' + (iso ? '<span>' + niceDate(iso) + '</span>' : '') + '<span>' + FT('rib_cny_prices', 'Festive prices apply') + '</span>';
    if (f === 'xmas') return '<b>' + (/-12-24$/.test(iso) ? FT('rib_xmas_eve', 'Christmas Eve order') : FT('rib_xmas_day', 'Christmas Day order')) + '</b><span>' + niceDate(iso) + '</span><span>' + FT('rib_xmas_msg', 'Merry Christmas from Fortune Food') + '</span>';
    return '';
  }
  function applyFest(f, iso) {
    var h = document.documentElement;
    h.classList.toggle('ff-fest', !!f); h.classList.toggle('ff-fest--cny', f === 'cny'); h.classList.toggle('ff-fest--xmas', f === 'xmas'); h.classList.toggle('ff-fest--ny', f === 'ny');
    var r = document.querySelector('[data-ff-fest-ribbon]');
    if (r) { r.hidden = !f; var t = r.querySelector('[data-ff-fest-text]'); if (t && f) t.innerHTML = ribbonText(f, iso); }
  }

  function toast(msg) {
    var t = document.querySelector('.ff-cny-toast');
    if (!t) { t = document.createElement('div'); t.className = 'ff-cny-toast'; t.setAttribute('role', 'status'); document.body.appendChild(t); }
    t.textContent = msg; t.classList.add('is-on');
    clearTimeout(t._h); t._h = setTimeout(function () { t.classList.remove('is-on'); }, 4500);
  }

  /* The planner saved a choice (date may still be without a time) */
  document.addEventListener('ffd:saved', function (e) {
    var a = (e.detail && e.detail.attrs) || {}, pick = (e.detail && e.detail.pick) || a['Delivery Date (YYYY-MM-DD)'] || '';
    var cny = a.Period === 'CNY';
    applyFest(festOf(pick, cny), pick);
    if (cny === state.cny) return;
    var wasCny = state.cny; state.cny = cny;
    /* Wait for the planner to save the attributes, then swap and refresh prices on the page */
    setTimeout(function () {
      reconcile().then(function (changed) {
        var onCart = /^\/(?:[A-Za-z]{2}(?:-[A-Za-z]+)?\/)?cart/.test(location.pathname);
        if (changed && wasCny) { try { sessionStorage.setItem('ffCnyNote', 'out'); } catch (er) {} }
        var showsPrices = onCart || document.querySelector('[data-product-price], .grid-product__price, .ff-qa__pr, [data-ffpax-prices]');
        /* Keep the date the customer just picked (it is only saved to the cart once a time is chosen) */
        try { if (pick) sessionStorage.setItem('ffdPick', JSON.stringify({ date: pick, method: a['Delivery Method'] || '', zip: a['Delivery Postal Code'] || '' })); } catch (er) {}
        if (onCart || showsPrices) setTimeout(function () { location.reload(); }, 150);
        else if (changed && wasCny) toast(FT('cny_back', 'Back to regular prices for your new date.'));
      });
    }, 700);
  });

  function start() {
    applyFest(CFG.fest || '', CFG.iso || '');
    try { if (sessionStorage.getItem('ffCnyNote') === 'out') { sessionStorage.removeItem('ffCnyNote'); toast(FT('cny_back', 'Back to regular prices for your new date.')); } } catch (e) {}
    /* Make sure the cart matches the period (e.g. items added in another tab) */
    if (state.cny || CFG.hasTwin) reconcile().then(function (ch) { if (ch && /^\/(?:[A-Za-z]{2}(?:-[A-Za-z]+)?\/)?cart/.test(location.pathname)) location.reload(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
